import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './WithdrawalDaysBox.module.scss';

const cn = classnames.bind(styles);

const knownPeriods = ['hours', 'days', 'weeks', 'months'];

// "3 days", "1 day", "2 weeks" — value + unit as configured on the tenant's product
export const WithdrawalPeriodLabel = ({ value, period }) => {
  const safePeriod = knownPeriods.includes(period) ? period : 'days';
  return <FormattedMessage id={`general.withdrawalPeriod.${safePeriod}`} values={{ count: Number(value) || 0 }} />;
};

WithdrawalPeriodLabel.propTypes = {
  value: T.oneOfType([T.number, T.string]),
  period: T.string,
};

// Read-only "USA W/D DAYS" / "EXPORT W/D DAYS" box used on ration cards and medication rows
const WithdrawalDaysBox = ({ label, value, period, className }) => (
  <div className={cn('WithdrawalDaysBox', className)}>
    <span className={cn('label')}>{label}</span>
    <span className={cn('value')}>
      <WithdrawalPeriodLabel value={value} period={period} />
    </span>
  </div>
);

WithdrawalDaysBox.propTypes = {
  label: T.oneOfType([T.string, T.node]).isRequired,
  value: T.oneOfType([T.number, T.string]),
  period: T.string,
  className: T.string,
};

export default WithdrawalDaysBox;
